var itemQuantityControl = function(e) {
  var $this = $(this)
}

var adjustItemQuantity = function(e){
  e.preventDefault();
  e.stopPropagation();

  var $this = $(this)
  if ($this.val()) {
    var quantity = $this.val()
  } else {
    var quantity = $this.data('qty');
  }
  var key = $this.data('key')

  var data = {
    id: key,
    quantity: quantity
  }
  changeCart(data)
}

// +++++++++++++++++++++
// AA: Helper Functions & variables
// +++++++++++++++++++++
var isMobile = function(){
  return window.screen.availWidth <= 960;
}

var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var scrollY;

var addNoScroll = function(){
  // only add to no scroll if the body doesn't already have it!
  if (!$(document.body).hasClass('no-scroll')) {
    scrollY = window.pageYOffset;

    $(document.body).css({ top: -(scrollY) + "px" });
    $('html').addClass('no-scroll');
    $(document.body).addClass('no-scroll');
  }
}

var removeNoScroll = function(){

  $(document.body).removeClass('no-scroll');
  $(document.body).css({ top: '' });

  window.scrollTo(0, scrollY || 0);
  $('html').removeClass('no-scroll');
}

var toggleNoScroll = function(){
  if (!$(document.body).hasClass('no-scroll')) {
    removeNoScroll()
  } else {
    addNoScroll()
  }
}

// +++++++++++++++++++++
// AA: Navigation Module
// +++++++++++++++++++++
var navigation = (function(){
  var settings = {
    clickLinks: ".js-mega-link",
    megaMenu: ".js-mega-menu",
    megaContainer: ".js-mega-container",
    overlay: ".js-overlay",
    activeClass: "active",
    hamburgerClass: "js-hamburger",
    closeMenuLink: '.js-icon-close',
    closeSubMenuLink: '.js-close-submenu'
  }

  var init = function(){
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    // event listeners here!
    $(settings.clickLinks).on('click', openMegaMenu);
    $(settings.closeMenuLink).on('click', closeMegaMenu);
    $(settings.closeSubMenuLink).on('click', closeSubMenu);
    $(settings.overlay).on('click', closeMegaMenu);
  }

  var openMegaMenu = function(e) {
    // Click on Shop -> open mega menu for Shop
    var $this = $(this);
    var menuReference = $this.data('link');
    var $menus = $(settings.megaMenu);
    var $containers = $(settings.megaContainer);

    var $activeMenu = $(settings.megaMenu + '[data-link="' + menuReference + '"]');
    var $activeContainer = $activeMenu.find(settings.megaContainer + '[data-link="' + menuReference + '"]');
    var hasOpenMenu = hasOpenMenus();

    var mobileScreen = isMobile();

    var hasSubMenu = $activeMenu.find('.mega-menu-link').length > 1;
  
    if (hasSubMenu) {
      // If there is a submenu, prevent default and open the submenu
      e.preventDefault();
    } else {
      // If there is no submenu, allow the default action (i.e., navigating to the link)
      return;
    }

    if ($activeMenu.length) {
      e.preventDefault();

      // The menu is currently open, so close it
      if ($this.hasClass(settings.activeClass)) {
        $this.toggleClass(settings.activeClass);
        closeMegaMenu();
        return;
      }

      $this.toggleClass(settings.activeClass);

      if (mobileScreen && hasOpenMenu && $this.hasClass(settings.hamburgerClass)) {
        closeMegaMenu();
      } else {
        if (mobileScreen) {
          addNoScroll();
          $activeMenu.addClass(settings.activeClass);
          $(settings.overlay).addClass(settings.activeClass);
        } else {

          if (hasOpenMenu) {
            // open the mega menu and close any other open menus
            $menus.not($activeMenu).removeClass(settings.activeClass);
            $activeMenu.addClass(settings.activeClass);
          } else {
            // no menus are open -> open & animate the active menu.
            $activeMenu.addClass(settings.activeClass);
          }

          $(settings.overlay).addClass(settings.activeClass);
          addNoScroll();
        }
      }
    }
  }

  var closeMegaMenu = function(e){
    $(settings.megaMenu).removeClass(settings.activeClass);
    $(settings.overlay).removeClass(settings.activeClass);
    $(settings.clickLinks).removeClass(settings.activeClass);

    removeNoScroll();
  }

  var closeSubMenu = function(e){
    e.preventDefault();

    var $this = $(this);
    var menuReference = $this.data('link');
    $(settings.clickLinks + '[data-link="' + menuReference + '"]').removeClass(settings.activeClass);
    var $activeMenu = $(settings.megaMenu + '[data-link="' + menuReference + '"]');
    $activeMenu.removeClass(settings.activeClass);
  }

  var hasOpenMenus = function(){
    return $(settings.megaMenu).hasClass(settings.activeClass);
  }

  return {
    init: init
  }
})();


// +++++++++++++++++++++
// SS: Slick Sliders
// +++++++++++++++++++++
var slickSliders = (function(){
  var settings = {
    testimonialSlider:".js-testimonial-slider",
    testimonialNav:".js-testimonial-nav",
    heroSlider: ".js-homepage-slideshow",
    homeIcons: ".js-home-icons",
    collectionSlider: ".js-collection-slider",
    blogSlider: ".js-blog-slider",
    relatedSlider: ".js-related-slider",
    pressSlider: ".js-press-slider"
  }

  var init = function(){
    // init sliders here!
    // Homepage
    // -----------
    if ($(settings.heroSlider).length) {
      $(settings.heroSlider).slick(heroSliderSettings);
    }

    if ($(settings.homeIcons).length) {
      $(settings.homeIcons).slick(homeIconsSettings);
    }

    // Featured Collection Product Cards
    if ($(settings.collectionSlider).length) {
      $(settings.collectionSlider).slick(collectionCardSlider);
    }

    // Featured Blog Posts
    if ($(settings.blogSlider).length) {
      $(settings.blogSlider).slick(blogCardSlider);
    }

    // Related products slider
    // $(settings.relatedSlider).slick(relatedSliderSettings);

    // Testimonials
    if ($(settings.testimonialSlider).length) {
      $(settings.testimonialNav).slick(testimonialNavSettings);
      $(settings.testimonialSlider).slick(testimonialSliderSettings);
    }

    // Press
    if ($(settings.pressSlider).length) {
      $(settings.pressSlider).slick(pressSliderSettings);
    }
  }

  var heroSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true
  }

  var homeIconsSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: '70px',
    arrows: false,
    dots: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: "unslick"
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 500,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  var collectionCardSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    mobileFirst: true,
    prevArrow: ".js-collection-prev",
    nextArrow: ".js-collection-next",
    responsive: [
      {
        breakpoint: 1000,
        settings: "unslick"
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  }

  var blogCardSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    mobileFirst: true,
    prevArrow: ".js-blog-prev",
    nextArrow: ".js-blog-next",
    responsive: [
      {
        breakpoint: 1000,
        settings: "unslick"
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  }

  var testimonialSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: true,
    prevArrow: '.js-testimonial-prev',
    nextArrow: '.js-testimonial-next',
    asNavFor: settings.testimonialNav
  }

  var testimonialNavSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    asNavFor: settings.testimonialSlider,
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  }

  var pressSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 600,
        settings: 'unslick'
      }
    ]
  }

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// SS: Accessibility
// +++++++++++++++++++++
var accessibility = (function(){
  var settings = {
    focusObject: ".focus-accessible"
  }

  var init = function(){
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    //Accessibility for opaque buttons
    $(settings.focusObject).on("focus", focusOn)
    $(settings.focusObject).on("blur", focusOn)
  }

  var focusOn = (function(){
    $(this).parent('.focus-parent').addClass('focus-visible');
  });

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// Cart
// +++++++++++++++++++++
var cart = (function(){
  var settings = {
    activeClass: "active",
    overlay: ".js-overlay",
    addToCart: "[action='/cart/add']",
    cartContainer: ".js-cart-container",
    cartLink: ".js-cart",
    moneyFormat: "${{ amount }}",
    closeCart: ".js-close-cart",
    cartRemove: ".js-remove-item",
    qtyAdjusters: ".js-adjust-qty",
    itemQty: ".js-item-qty",
    cartItems: ".js-cart-items",
    cartFooter: ".js-cart-footer",
    cartCount: ".js-cart-count",
    checkoutButton: '.js-process-checkout',
    rechargeItems: ".js-recharge-item",
    cartNoteCheckbox: ".js-cart-note-toggle",
    cartNoteContainer: ".js-cart-note-container",
    cartNoteText: ".js-cart-note",
    noteType: ".js-note-type",
    saveNoteBtn: ".js-note-save",
    bundlerItems: ".js-bundler-property"
  }

  var cartNotesEnabled = true;
  var noteType = "gift-message"

  var init = function(){
    var $section = $(settings.cartContainer);

    if (!$section.length) {
      return;
    }

    initializeEventListeners();
    getCart();
  }

  var initializeEventListeners = function(){
    $(document).on('submit', settings.addToCart, addToCart);
    $(settings.cartLink).on('click', openCart);
    $(document).on('click', settings.cartRemove, adjustItemQuantity);
    $(document).on('click', settings.qtyAdjusters, adjustItemQuantity);
    $(document).on('change', settings.itemQty, adjustItemQuantity);
    $(document).on('click', settings.overlay + ", " + settings.closeCart,  closeCart);
    $(document).on('click', settings.checkoutButton, processCart);

    $(document).on('click', settings.cartNoteCheckbox, toggleCartNote);
    $(document).on('click', settings.saveNoteBtn, updateCartNote);
    $(document).on('change', settings.noteType, changeNoteType);
  }

  var processCart = function(e){
    if ($(settings.bundlerItems).length) {
      e.preventDefault()
      getCart(sendCartToBundle);
    } else if ($(settings.rechargeItems).length){
      e.preventDefault()
      reChargeProcessCart();
    } else {
      location.pathname = '/checkout';
    }
  }

  var get_cookie = function(name){
    return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2];
  }

  var reChargeProcessCart = function() {
  	do {
  		token=get_cookie('cart');
  	}
  	while(token == undefined);
    var myshopify_domain='spicewallabrand.myshopify.com'
  	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
  	var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
    location.href = checkout_url;
  }

  var sendCartToBundle = function(cart){

    // send post to Spicewalla Bundler App
    var url = "https://spicewalla-bundler.herokuapp.com/shopify/build-bundle"
    var options = {
      method: "POST",
      body: JSON.stringify({cart: cart}),
      headers: {
        'Content-Type': "application/json",
        'Accept': "application/json"
      }
    }

    fetch(url, options)
      .then(function(res) { return res.json() })
      .then(function(json) {
        if (json && json.webUrl) {
          location.href = json.webUrl.replace("spicewallabrand.myshopify.com", "spicewallabrand.com");
        } else {
          location.href = '/checkout'
        }
      })
      .catch(function(error){
        location.href = '/checkout'
      })
  }

  var toggleCartNote = function(e){
    var $this = $(this);
    var $cartNoteContainer = $(settings.cartNoteContainer);

    if ($cartNoteContainer.hasClass('active')) {
      $this.find('span').text("+ Add A Note");
    } else {
      $this.find('span').text("+ Edit Note");
    }

    $cartNoteContainer.toggleClass('active');
  }

  var changeNoteType = function(e){
    // update note placeholder
    // update button text
    //
    var $this = $(this);
    noteType = $this.val();

    if (noteType === "gift-message") {
      $(settings.cartNoteText).prop('placeholder', 'your gift message here...');
      $(settings.saveNoteBtn).find('.js-gift-message').removeClass('hide');
      $(settings.saveNoteBtn).find('.js-order-note').addClass('hide');
    } else {
      $(settings.cartNoteText).prop('placeholder', 'your order note here...');
      $(settings.saveNoteBtn).find('.js-gift-message').addClass('hide');
      $(settings.saveNoteBtn).find('.js-order-note').removeClass('hide');
    }

  }

  var updateCartNote = function(e){
    var $this = $(this);
    var $noteText = $(settings.cartNoteText);
    var note = $noteText.val();

    $this.text('Saving...').attr('disabled', true);

    var params = {
      url: "/cart/update.js",
      data: { note: note },
      dataType: "json",
      success: function(cart){
        // buildCart(cart);
        $this.text('Saved!').attr('disabled', false);

        setTimeout(function(){
          if (noteType === "gift-message") {
            $(settings.saveNoteBtn).find('.js-gift-message').removeClass('hide');
            $(settings.saveNoteBtn).find('.js-order-note').addClass('hide');
            $(settings.saveNoteBtn).attr('disabled', false);
          } else {
            $(settings.saveNoteBtn).find('.js-gift-message').addClass('hide');
            $(settings.saveNoteBtn).find('.js-order-note').removeClass('hide');
            $(settings.saveNoteBtn).attr('disabled', false);
          }
        }, 200)

        setTimeout(function(){
          $this.text('Save')
        }, 2000)

      }
    }
    $.ajax(params);
  }

  var updateCartCount = function(cart){
    var $cartCount = $(settings.cartCount)
    $cartCount.text(cart.item_count)

    if (cart.item_count === 0) {
      $cartCount.addClass("hide")
    } else {
      $cartCount.removeClass("hide")
    }
  }

  var getCart = function(callback){
    var params = {
      url: "/cart.js",
      dataType: "json",
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }

    $.ajax(params)
  }

  var getProduct = function(productHandle, callback){
    var params = {
      url: `/products/${productHandle}.js`,
      dataType: "json",
      async: false,
      success: function(product) {
        if (callback) {
          callback(product)
        }
      }
    }
    return $.ajax(params)
  }

  var onCartUpdate = function(){
    // Event for any cart updates
    // get cart, build cart, update cart count
    getCart();
    openCart();
  }

  var changeCart = function(data, callback){
    var params = {
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }
    $.ajax(params);
  }

  var addToCart = function(e){
    e.preventDefault();

    var btn = $(e.target).find("button");
    var body = $(this).serialize();

    btn.attr("disabled", true);

    var params = {
      url: "/cart/add.js",
      dataType: "json",
      data: body,
      method: "POST",
      success: function(item){
        onCartUpdate();
      },
      complete: function() {
        btn.attr("disabled", false);
      }
    }

    $.ajax(params);
  }

  var adjustItemQuantity = function(e){
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this)
    if ($this.val()) {
      var quantity = $this.val()
    } else {
      var quantity = $this.data('qty');
    }
    var key = $this.data('key')

    var data = {
      id: key,
      quantity: quantity
    }
    changeCart(data)
  }

  var openCart = function(e) {
    if (e) {
      e.preventDefault();
    }
  
    var $cartContainer = $(settings.cartContainer);
    $cartContainer.addClass(settings.activeClass);
    
    var overlay = $(settings.overlay);
    overlay.css({
      top: 0
    });
    overlay.addClass([settings.activeClass, "cart-overlay"]);
    addNoScroll();
  };

  var closeCart = function(){
    var $cartContainer = $(settings.cartContainer);
    $cartContainer.removeClass(settings.activeClass);
    var overlay = $(settings.overlay);
    overlay.removeClass([settings.activeClass, "cart-overlay"]);
    removeNoScroll();
  }

  var buildCart = async function(cart){
    updateCartCount(cart);

    var $cartContainer = $(settings.cartItems);
    var $cartFooter = $(settings.cartFooter);
    $cartContainer.empty();
    $cartFooter.empty();

    var items = []
    var item = {}
    var data = {}
    var source = $("#CartTemplate-Items").html()

    if (!source) return;

    var template = Handlebars.compile(source);
    var footerSource = $("#CartTemplate-Footer").html()
    var footerTemplate = Handlebars.compile(footerSource);

    $.each(cart.items, function(index, cartItem) {
      var prodImg = {}
      
      getProduct(cartItem.handle, function(product) {
        var selectedVariant = product.variants.find(variant => variant.id === cartItem.variant_id)

        if (cartItem.image != null){
          prodImg.src = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
          prodImg.dataSrc = cartItem.image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
        } else {
          prodImg.src = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
          prodImg.dataSrc = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        var propertyList = "";

        if (cartItem.properties && cartItem.properties.shipping_interval_frequency) {
          if (parseInt(cartItem.properties.shipping_interval_frequency) === 1) {
            var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type.replace('s', '').toLowerCase();
          } else {
            var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type
          }
        } else if (cartItem.properties) {
          Object.keys(cartItem.properties).forEach(function(key){
            if (!key.includes("_")) {
              propertyList += "<li class='mb-none js-bundler-property'>" + key + " x <span class='bold'>" + cartItem.properties[key] + "</span></li>"
            }
          })
        } else {
          var rechargeProperties = null
        }

        var comparePrice;

        if (selectedVariant.compare_at_price) {
          comparePrice = formatMoney(selectedVariant.compare_at_price, settings.moneyFormat)
        } else {
          comparePrice = null;
        }

        item = {
          key: cartItem.key,
          line: index + 1, //Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          propertyList: propertyList,
          rechargeProperties: rechargeProperties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: formatMoney(cartItem.final_price, settings.moneyFormat),
          comparePrice,
          vendor: cartItem.vendor,
          linePrice: formatMoney(cartItem.line_price, settings.moneyFormat),
          originalLinePrice: formatMoney(cartItem.original_line_price, settings.moneyFormat),
          discounts: cartItem.discounts,
          discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
        };

        items.push(item)
      })
   })

   data = {
     emptyCart: cart.item_count === 0,
     cartCount: cart.item_count,
     items: items,
     note: cart.note,
     giftNote: noteType === "gift-message",
     orderNote: noteType === "order-note",
     totalPrice: formatMoney(cart.total_price, settings.moneyFormat),
     totalCartDiscount: cart.total_discount === 0 ? 0 : 0,
     totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
   }

   $cartContainer.append(template(data));
   $cartFooter.append(footerTemplate(data));
  }

  var refreshOffer = () => {
    $('.js-cart-upsell').empty()
  }

  return {
    init: init,
    getCart: getCart,
    onCartUpdate: onCartUpdate,
    refreshOffer: refreshOffer
  }
})();

// +++++++++++++++++++++
// Accordion
// +++++++++++++++++++++
var accordion = (function(){

  var settings = {
    title: ".js-panel-title a"
  }

  var init = function(){
    if ($(settings.title).length === 0) return;

    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    $(settings.title).on('click', togglePanel);
  }

  var togglePanel = function() {
    if ($(this).attr( 'aria-expanded' ) == 'false'){
      $(this).parents( '.js-accordion' ).find( '[aria-expanded=true]' ).attr( 'aria-expanded' , false ).removeClass( 'active' ).parent().next( '.js-panel-content' ).slideUp(200).attr( 'aria-hidden' , 'true');
      $(this).attr( 'aria-expanded' , true ).addClass( 'active' ).parent().next( '.js-panel-content' ).slideDown(200).attr( 'aria-hidden' , 'false');
    } else {
      $(this).attr( 'aria-expanded' , false ).removeClass( 'active' ).parent().next( '.js-panel-content' ).slideUp(200).attr( 'aria-hidden' , 'true');;
    }
    // No Boing Boing
    return false;
  };

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// Product
// +++++++++++++++++++++
var productPage = (function(){
  var settings = {
    container: ".product-panel",
    productImages: ".js-product-slider",
    productThumbs: ".js-product-thumbs",
    qtyAdjust: ".js-qty-adjust",
    productSelect: "[name='id']",
    productSection: ".product-section",
    productPrice: ".js-product-price",
    compareAtProductPrice: ".js-compare-price",
    productRecommendations: ".js-product-recommendations",
    productJson: "#Product-JSON",
    moneyFormat: "${{ amount }}",
  }

  var product = {};

  var init = function(){
    if (!$('body').hasClass('template-product')) return;

    if ($(settings.productJson).length) {
      product = JSON.parse($(settings.productJson).text());
    }

    initSliders();
    initializeEventListeners();
    getProductRecommendations();
  }

  var config = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    prevArrow: ".slick-arrow-prev",
    nextArrow: ".slick-arrow-next",
    //asNavFor: settings.productThumbs,
    adaptiveHeight: window.screen.availWidth <= 768
  }

  var thumbConfig = {
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false,
    draggable: false,
    asNavFor: settings.productImages
  }

  var initSliders = function(){
    //$(settings.productThumbs).slick(thumbConfig);
    $(settings.productImages).slick(config);
  }

  var initializeEventListeners = function(){
    $(settings.qtyAdjust).on("click", updateQuantity);
    $(settings.productSelect).on("change", updateVariant);

    if ($(settings.productSelect).length > 1){
      $(settings.productSelect + ":checked").change();
    } else {
      $(settings.productSelect).change();
    }

  }

  var updateVariant = function(e){
    var value = $(this).val();

    if (product) {
      var currentVariant = product.variants.find(function(variant){
        return variant.id === parseInt(value);
      })

      if (currentVariant) {
        updatePrice(currentVariant);
        changeSlideOnSelect(currentVariant);
        updateBodyContent(currentVariant);
        // anything else we might want to update: default images, image in slider, product title
      }
    }
  }

  var updatePrice = function(variant) {
    var formattedPrice = formatMoney(variant.price, settings.moneyFormat);
    var formattedCompareAtPrice = formatMoney(variant.compare_at_price, settings.moneyFormat);
  
    $(settings.productPrice).text(formattedPrice);
  
    if (variant.compare_at_price) {
      $(settings.compareAtProductPrice).text(formattedCompareAtPrice);
    } else {
      $(settings.compareAtProductPrice).text('');
    }
  };
  

  var changeSlideOnSelect = function(variant) {
    var slider = $('.js-product-slider');
    slider.slick('slickUnfilter');

    var featuredVariantImage = slider.find('.slick-slide[data-variant-id="' + variant.id +'"]').not(".slick-cloned");

    // hide all other variant images
    $('.slick-slide[data-variant-id]').removeClass('js-show');
    featuredVariantImage.addClass('js-show');

    slider.slick('slickFilter', '.js-show');

    var index = $('.js-show').not('.slick-cloned').index(featuredVariantImage);

    if (index !== -1) {
      slider.slick('slickGoTo', index);
    }
  }

  var updateBodyContent = function(variant){
    $('.js-variable-content').hide();
    var relatedContent = $('.js-variable-content[data-variant-id="' + variant.id +'"]');
    relatedContent.show();
  }

  // AA fixed for multiple inputs.
  var updateQuantity = (function(e) {
    e.preventDefault();

    var $qtyInput = $(this).siblings('.js-qty-input');

    var qty = $qtyInput.val();

    if ($(this).data("action") == "increase") {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }

    qty = (isNaN(qty)) ? 1 : qty;
    $qtyInput.val(qty).trigger('change');
  });

  // MC: Get product recommendations
  var getProductRecommendations = function() {
    var products = [];
    // Look for the element that will contain the product cards
    var $container = $(settings.productRecommendations);
    // Read product id from data attribute
    var productId = $container.data("product-id");
    // Read base URL from data attribute
    var baseUrl = $container.data("base-url");
    // Read limit from data attribute
    var limit = $container.data("limit");
    // Build request URL
    var requestUrl = baseUrl + ".json?product_id=" + productId + "&limit=" + limit;

    var source = $("#CardTemplate").html();
    if (!source) return

    var template = Handlebars.compile(source);


    // Bail out if the container element doesn't exist
    if ($container === null) {
      return;
    }

    $.ajax(requestUrl).then(function(response) {
      var products = [];

      $.each(response.products, function(index, productItem) {
        var prodImg = {}

        if (productItem.images[0] != null){
          prodImg.src = productItem.images[0].replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
          prodImg.dataSrc = productItem.images[0].replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
        } else {
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        var defaultVariant = productItem.variants[0];

        var productRec = {
          url: "/products/" + productItem.handle,
          img: prodImg,
          defaultVariant: defaultVariant,
          defaultAvailable: defaultVariant.available,
          onlyDefault: productItem.variants.length == 1,
          productTitle: productItem.title,
          variantTitles: productItem.variant_title,
          variants: productItem.variants,
          price: formatMoney(defaultVariant.price, settings.moneyFormat),
          priceVaries: productItem.price_varies,
          fromPrice: formatMoney(defaultVariant.compare_at_price, settings.moneyFormat),
          onSale: defaultVariant.compare_at_price > defaultVariant.price,
          showAddToCartButton: false,
        };

        var cardClasses = ['product-grid-item full-height'];

        if (productRec.onSale) {
          cardClasses.push('on-sale');
        }

        if (productRec.showAddToCartButton) {
          cardClasses.push('show-button');
        }

        if ( ! productRec.defaultAvailable) {
          cardClasses.push('sold-out');
        }

        productRec.cardClasses = cardClasses.join(' ');

        products.push(productRec);
      })

      var context = { products: products };
      var html = template(context);

      $container.append(html);

      // this where we need slick
      $(settings.productRecommendations).slick(relatedSliderSettings);
      $(settings.productRecommendations).find(".will-animate").addClass("animate");
    });
  }

  var relatedSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    mobileFirst: true,
    infinite: true,
    prevArrow: ".js-collection-prev",
    nextArrow: ".js-collection-next",
    centerMode: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  }

  return {
    init: init
  }
})();

// AA Animation Module
// Use for adding animations on page scroll / element in view

var animations = (function(){
  var classes = {
    willAnimate: '.will-animate',
    isAnimating: 'animate',
  }

  var observeAnimations = function(entries, observer){
    entries.forEach(entry => {
      let $target = $(entry.target);
      if (!$target.hasClass(classes.isAnimating) && entry.isIntersecting) {
        let delay = $target.data('delay')
        if (delay) {
          setTimeout(function(){
            $target.addClass(classes.isAnimating);
          }, parseInt(delay))
        } else {
          $target.addClass(classes.isAnimating);
        }
      }
    })
  }

  var initializeAnimationsObserver = function(){

    if (typeof IntersectionObserver === "function") {
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: .05
      }

      let observer = new IntersectionObserver(observeAnimations, options);

      let $targets = $(classes.willAnimate);

      $targets.each(function(index, target){
        observer.observe(target);
      });
    } else {
      let $targets = $(classes.willAnimate).addClass(classes.isAnimating);
    }
  }

  var init = function(){
    if ($(classes.willAnimate).length === 0 ) {
      return
    }

    initializeAnimationsObserver();
  }

  return {
    init: init
  }
})();



// +++++++++++++++++++++
// Account
// +++++++++++++++++++++
var account = (function() {
  var settings = {
    recoverPasswordForm: "#RecoverPasswordForm",
    customerLoginForm: "#CustomerLoginForm",
    recoverPasswordLink: ".js-recover-password",
    container: "#account-page",
    accountAddresses: ".address-country-option",
    newAddressToggle: ".address-new-toggle",
    newAddressForm: "#AddressNewForm",
    editAddressToggle: ".address-edit-toggle",
  }

  var init = function(){
    if ($(settings.container).length === 0) {
      return;
    }

    initializeEventListeners();
    initializeAddressForms();
  }

  var initializeEventListeners = function(){
    $(settings.recoverPasswordLink).on('click', toggleRecoverForm);
    $(settings.newAddressToggle).on('click', toggleNewAddressForm);
    $(settings.editAddressToggle).on('click', toggleEditAddressForm);
  }

  var toggleRecoverForm = function(e){
    e.preventDefault();
    $(settings.customerLoginForm).toggleClass('hide');
    $(settings.recoverPasswordForm).toggleClass('hide');
  }

  var toggleEditAddressForm = function(e){
    e.preventDefault();

    var formId = $(this).attr('aria-owns');
    var $form = $("#" + formId);

    $form.toggleClass('hide');

    if ($form.hasClass('hide')) {
      $(this).text('edit');
    } else {
      $(this).text('cancel');
    }
  }

  var toggleNewAddressForm = function(e){
    e.preventDefault();
    $(settings.newAddressForm).toggleClass('hide');

    if ($(settings.newAddressForm).hasClass('hide')) {
      $(this).text('new address');
    } else {
      $(this).text('cancel');
    }
  }

  var initializeAddressForms = function(){
    $(settings.accountAddresses).each(function(index, element){
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  }

  return {
    init: init
  };
})();

let dropdownMenus = (function(){
  var settings = {
    wrapper: '.js-dropdown-wrapper',
    trigger: '.js-dropdown-trigger',
    dropdown: '.js-dropdown',
    filterClose: '.js-filter-close',
    sortClose: '.js-sort-close'
  };

  let init = function(){
    $(document).on('click', settings.trigger, toggleFilters);
    $(settings.filterClose).on('click', closeFilter);
    $(settings.sortClose).on('click', closeFilter);
  }

  var toggleFilters = function(e) {
    var $target = $(this);
    var $currentDropdown = $target.closest(settings.wrapper);

    // Click was triggered inside the Filter or Sort dropdown
    if ($currentDropdown.length !== 0) {
      // Close the other dropdown
      $(settings.wrapper).not($currentDropdown).find(settings.trigger).removeClass("active").next(settings.dropdown).hide();

      // The click happened in the dropdown trigger element, so an additional check is needed
      // to know whether the dropdown should be closed (if it's already open), or viceversa
      if ($target.is(settings.trigger)) {
        var $dropdownMenu = $target.next();

        if ($target.hasClass("active")) {
          // Hide the menu if it's open...
          $dropdownMenu.slideUp(200);
        } else {
          // ...or show it if it's not
          $dropdownMenu.slideDown(200);
        }

        // Finally toggle the 'active' class of the trigger element
        $target.toggleClass("active");
      }
    } else {
      // Click was triggered outside the dropdown wrapper (somewhere
      // else in the document) so we can close any open dropdown
      closeFilters();
    }
  }

  var closeFilters = function(e) {
    $(settings.trigger).removeClass("active").next().hide();
  }


  var closeFilter = function(){
    $(this).parent().slideUp(200);
  }

  return {
    init: init
  }
})()


// Filters and collection/search
var filters = (function(){
  var settings = {
    sort: '.js-sort',
    sortText: '.js-sort-text',
    filter: '.js-filter',
    trigger: '.js-dropdown-trigger',
    cardItems: '.js-collection-card-wrapper',
    input: ".js-filter-input",
    sortInput: ".js-sort-input",
    filtersContainer: ".js-filters-container",
    searchContainer: '.js-search-container',
    moneyFormat: "${{ amount }}",
    pageBtn: '.js-pagination',
    paginationList: '.js-pagination-list',
    variantDropdown: '.js-product-grid-dropdown-toggle',
    variantMenu: '.js-product-grid-dropdown-menu',
    variantInput: '.js-product-grid-variant-input',
  };

  var products, activeFilters = [], searchResults, page = 1, perPage = 32;

  var initializeEventListeners = function(){
    $(settings.input).on('change', filterProducts);
    $(settings.sortInput).on('click', sortProducts);
    $(settings.pageBtn).on('click', pagination);

    $(document).on('click', settings.variantDropdown, toggleProductVariants);
    $(document).on('click', handleDocumentClick);
    $(document).on('change', settings.variantInput, addVariantToCart);
  }

  var pagination = function(e){
    e.preventDefault()
    $this = $(this);
    var currentPage = page;

    page = parseInt($this.data('page'));

    if (currentPage !== page) {
      // Scroll to the top of the collection container
      $('html, body').animate({
        scrollTop: $(settings.cardItems).offset().top
      }, 200);
      // update the active button
      $('.js-page-item').removeClass('active');
      $this.parent().addClass('active');

      if (window.location.pathname.includes('search')) {
        renderSearchResults();
      } else {
        applyFilters();
      }
    }

  }

  var closeFilters = function(e) {
    $(settings.trigger).removeClass("active").next().hide();
  }

  var sortURLMap = {
    "ascending": "?sort_by=price-ascending",
    "descending": "?sort_by=price-descending",
    "best-selling": "?sort_by=best-selling",
    "featured": "?sort_by=manual"
  }

  var sortProducts = function(){
    var $this = $(this);
    var text = $this.text();
    var sortData = $this.data('sort');
    var urlParam = sortURLMap[sortData];

    if (urlParam) {
      getProductsWithSort(urlParam)

      $(settings.sortText).text(text);
    }

    // if (window.location.pathname.includes('search')) {
    //   if (sortData.includes('ascending')) {
    //     searchResults.sort(ascending);
    //   }else if(sortData.includes('descending')){
    //     searchResults.sort(descending);
    //   }else if(sortData.includes('best selling')){
    //     searchResults.sort(bestSelling);
    //   }else if(sortData.includes('featured')){
    //     searchResults.sort(featured);
    //   }
    //   renderSearchResults();
    // } else {
    //   if (sortData.includes('ascending')) {
    //     products.sort(ascending);
    //   } else if(sortData.includes('descending')){
    //     products.sort(descending);
    //   } else if(sortData.includes('best selling')){
    //     products.sort(bestSelling);
    //   } else if(sortData.includes('featured')){
    //     products.sort(featured);
    //   }
    //   renderProducts(products);
    // }

    closeFilters();
  }

  var getProductPackSizes = function(productItem){
    var tags = [];

    if (productItem.variants.length === 1) {
      // only has default variant -> use the product title to determine the pack size
      var productTitle = productItem.title.toLowerCase()
      if (productTitle.includes('pack')) {
        var match = productTitle.match(/(pack)/);
        if (match) {
          var packSize = productTitle.match(/\d+/)[0];
          // var packSize = parseInt(productTitle.slice(0, match.index));
          if (packSize && !tags.includes(packSize)) {
            tags.push(packSize);
          }
        }
      }
    } else {
      // has multiple variants -> use the variant titles to determine the pack sizes
      productItem.variants.forEach(function(variant){
        var productTitle = variant.title.toLowerCase();
        if (productTitle.includes('pack')) {
          var match = productTitle.match(/(pack)/);
          if (match) {
            var packSize = productTitle.match(/\d+/)[0];
            // var packSize = parseInt(productTitle.slice(0, match.index));
            if (packSize) {
              tags.push(packSize);
            }
          }
        }
      })
    }

    return tags;
  }

  var filterProducts = function() {
    var $this = $(this);

    $this.next('label').toggleClass('active');

    if ($this.is(':checked')) {
      activeFilters.push($this.val());
    } else {
      activeFilters = activeFilters.filter(function(value) {
        return value != $this.val();
      });
    }

    updatePagingation();
    applyFilters();
  }

  var updatePagingation = function(){
    page = 1;
    $('.js-page-item').removeClass('active');
    $('.js-page-item').eq(0).addClass('active');
  }

  var applyFilters = function(){
    if (location.pathname.includes('search')) {
      // $.each(searchResults, function(index, searchItem) {
      //   if (searchItem.error == null) {
      //
      //     if (!Array.isArray(searchItem.tags) ) {
      //       searchItem.tags = searchItem.tags.split(', ');
      //     }
      //
      //     if (searchItem.tags.some(r=> activeFilters.includes(r))) {
      //       searchItem.tagHide = true;
      //     } else{
      //       searchItem.tagHide = false;
      //     }
      //   }
      // });

      renderSearchResults();
    } else {
      var filteredProducts = products.filter(function(productItem){
        if (activeFilters.length) {
          // There are active filters selected
          var productIsActive = activeFilters.some(function(filter){
            // normalize filters to lowercase
            var filterLowercase = filter.toLowerCase();

            if (filterLowercase.includes('pack')) {
              // pack size filters
              // AA: need to reformat for 3 pack small tin vs 3 pack big tin

              var filterSize = filterLowercase.match(/\d+/)[0];
              var tags = getProductPackSizes(productItem);

              if (tags.includes(filterSize)) {
                return true
              }
            } else if (true) {
              // All other filters are controlled by tags instead of product / variant titles
              // tags used for filtering:
              if (productItem.tags) {
                return productItem.tags.find(tag => {
                  return (tag.includes("_filters") && tag.toLowerCase().includes(filterLowercase))
                })
              } else return false
            }
          });

          return productIsActive;
        } else {
          // No filters selected. Render all products in the collection
          return true;
        }
      });

      renderProducts(filteredProducts);
    }
  }

  var renderSearchResults = function(){
    var $searchContainer = $(settings.searchContainer);
    $searchContainer.empty();

    var items = []
    var item = {}
    var data = {}
    var source = $("#SearchTemplate").html();
    if (!source) return;
    var template = Handlebars.compile(source);

    $.each(searchResults, function(index, searchItem) {
      if (!!searchItem.error) {
        // If an error is returned product is in draft mode, exit loop
        return;
      }

      var prodImg = {}

      if (searchItem.featured_image != null){
        prodImg.src = searchItem.featured_image.replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
        prodImg.dataSrc = searchItem.featured_image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
      } else if (searchItem.image != null){
        prodImg.src = searchItem.image.src.replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
        prodImg.dataSrc = searchItem.image.src.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var urlSpace;
      if (searchItem.blog_id != null) {
        urlSpace = "/blogs/recipes/"
      } else {
        urlSpace = "/products/"
      }

      item = {
        url: urlSpace + searchItem.handle,
        img: prodImg,
        title: searchItem.title,
        price: formatMoney(searchItem.price, settings.moneyFormat),
        hasPrice: searchItem.price != undefined
      };

      items.push(item);
   })

   data = {
     results: items
   }

   $('.js-search-results-count-text').text(`${items.length} RESULTS`)

   $searchContainer.append(template(data));
  }

  var getSearchResults = function(){
    var searchParams = window.location.search;
    var path = window.location.pathname;
    if (path.includes('search')) {
      searchResults = window.searchJson;
      renderSearchResults();
    }
  }

  var getProducts = function(){
    if (window.productJson) {
      products = window.productJson;
      renderProducts(products);
    } else {
      var collection = window.location.pathname;
      if (!collection.includes('search') && collection != "/") {
        $.ajax(collection + "/products.json").then(function(response){
          products = response;
          renderProducts(products);
        });
      } else {
        $.ajax("/products.json").then(function(response){
          products = response;
          renderProducts(products);
        });
      }
    }
  }

  

  var getProductsWithSort = function(urlParam){
    if (urlParam) {
      var collection = window.location.pathname;
      var collectionURL = collection + urlParam + "&view=sort-json"
      $.ajax(collectionURL)
        .then(function(response){
          var responseScript = $(response).find("#sorted-product-json");
          var productsJSON = JSON.parse(responseScript.text());
          if (productsJSON) {
            products = productsJSON;
          }

          applyFilters();
        });
    } else {
      // default sort
      getProducts();
    }
  }

  var toggleProductVariants = function() {
    closeProductVariants();

    $(this).next().toggleClass('active');
  }

  var handleDocumentClick = (e) => {
    var $target = $(e.target);
    if ($target.hasClass('js-collection-card-wrapper')) {
      closeProductVariants();
    }
  }

  var closeProductVariants = function() {
    $(settings.variantDropdown).next().removeClass('active');
  }

  var addVariantToCart = function(e) {
    $this = $(this);
    $form = $this.parents('form');
    $addToCartBtn = $form.find('button');

    $dropdownMenu = $addToCartBtn.next();

    $addToCartBtn
      .attr('type', 'submit')
      .trigger('click')
      .text('Added to Cart')
      .addClass('adding');

    $dropdownMenu.removeClass('active');

    $form.find(settings.variantInput).prop('checked', false);

    setTimeout(function(){
      $addToCartBtn
        .attr('type', 'button')
        .removeClass('adding')
        .text('Add to Cart')
        .prop('disabled', false);
    }, 5000)
  }

  var renderProducts = function(products) {
    var $cardContainer = $(settings.cardItems);
    var variantSKU = $cardContainer.data('variantOption');
    $cardContainer.empty();

    var productItems = [];
    var product = {};
    var data = {};
    var source = $("#CardTemplate").html();

    if (!source) return;
    var template = Handlebars.compile(source);
    var $paginationContainer = $(".js-pagination-container");
    // @arren start here for
    var start = ((page - 1) * perPage);
    var end = (page  * perPage);

    var slicedProducts = products.slice(start, end);

    $.each(slicedProducts, function(index, productItem) {
      var prodImg = {}

      let defaultVariant;

      if (variantSKU) {
        // Set the default variant as the one that's on sale, IF it's in stock
        defaultVariant = productItem.variants.find(variant => variant.available && (variant.compare_at_price === productItem.compare_at_price_min));

        // If it's not in stock, set it as the one that is in stock
        if (!defaultVariant) {
          defaultVariant = productItem.variants.find(variant => variant.available);
        }

        if (defaultVariant && defaultVariant.featured_image) {
          prodImg.src = defaultVariant.featured_image.src.replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
          prodImg.dataSrc = defaultVariant.featured_image.src.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
        } else {
          prodImg.src = productItem.images[0].replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
          prodImg.dataSrc = productItem.images[0].replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
        }
      } else {
        if (productItem.images[0] != null){
          prodImg.src = productItem.images[0].replace(/(\.[^.]*)$/, "_325x$1").replace('http:', '');
          prodImg.dataSrc = productItem.images[0].replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
        } else {
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
      }


      if (!defaultVariant) {
        defaultVariant = productItem.variants[0];
      }

      var tags = getProductPackSizes(productItem);
      var filterTags = [];

      product = {
        url: "/products/" + productItem.handle + "?variant=" + defaultVariant.id,
        img: prodImg,
        defaultVariant: defaultVariant,
        defaultNotAvailable: !defaultVariant.available,
        onlyDefault: productItem.variants.length == 1,
        productTitle: productItem.title,
        variantTitles: productItem.variant_title,
        variants: productItem.variants,
        price: formatMoney(defaultVariant.price, settings.moneyFormat),
        priceVaries: productItem.price_varies,
        fromPrice: formatMoney(defaultVariant.compare_at_price, settings.moneyFormat),
        onSale: defaultVariant.compare_at_price > defaultVariant.price,
        bundleTemplate: $(settings.cardItems).hasClass('bundles'),
        tags: tags,
        hasMultiplePacks: tags.length > 1,
        showAddToCartButton: true,
      };
      

      var cardClasses = '';

      if (product.onSale) {
        cardClasses += ' on-sale';
      }

      if (!product.defaultAvailable) {
        cardClasses += ' sold-out'
      }

      product.cardClasses = cardClasses;

      product.variants.map(variant => {

        if (variant.compare_at_price) {
          variant.display_compare_at_price = formatMoney(variant.compare_at_price, settings.moneyFormat)
          variant.on_sale = true;
        }
      if (variant.price) {
        variant.price = formatMoney(variant.price, settings.moneyFormat);
      }
    })
    productItems.push(product);
  });

   data = {
     products: productItems,
     productsEmpty: productItems.length === 0
   }

   $cardContainer.append(template(data));

   var pageCount = products.length / 30
   pageCount = Math.ceil(pageCount);

   $('.js-page-item').show();
   $('.js-page-item').slice(pageCount, 1000).hide();

   if (products && products.length > 30) {
     $paginationContainer.removeClass("hide");
   } else {
     $paginationContainer.addClass("hide");
   }

   $('.product-grid-item').addClass('animate');
  }
 


  var init = function(){
    // @arren: needs a way to check if this module should run

    if ($(settings.filtersContainer).length) {
      initializeEventListeners();
      getProducts();
      getSearchResults();
    }
  }

  return {
    init: init
  }
})();


// Collection Add to Cart Buttons
var collectionATC = (function(){
  var settings = {
    atc: '.js-bundle-btn',
    variantDropdown: '.variant-atc',
    collectionatc: '.js-collection-atc'
  }

  var initializeEventListeners = function(){
    $(document).on('click', settings.atc,toggleATC);
    $(document).mouseup(closeATC);
    $(document).on('click', settings.collectionatc, addedToCart);
  }

  var addedToCart = function(){
    var container = $(settings.variantDropdown);
    var hasDefault = $(this).hasClass('js-default');
    var $this = $(this);
    if (hasDefault) {
      $this.addClass('added');
      $this.text('Added To Cart');
    }else{
      $this.parent().parent().siblings(settings.atc).addClass('added');
      $this.parent().parent().siblings(settings.atc).text('Added To Cart');
    }

    setTimeout(function(){
      if (hasDefault) {
        $this.removeClass('added');
        $this.text('Add To Cart');
        $this.blur();
      }else{
        $(settings.atc).removeClass('added');
        $(settings.atc).text('Add To Cart');
      }

    }, 3000);

    $(settings.variantDropdown).slideUp(200);
  }

  var closeATC = function(e){
    var container = $(settings.variantDropdown);

    if(!container.is(e.target) && container.has(e.target).length === 0){
      $(settings.variantDropdown).slideUp(200);
    }
  }

  var toggleATC = function(){
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $(this).siblings(settings.variantDropdown).slideDown(200);
    }else{
      $(this).siblings(settings.variantDropdown).slideUp(200);
    }
  }

  var init = function(){
    initializeEventListeners();
  }

  return{
    init: init
  }
})();

var blogPage = (function() {
  var settings = {
    menuToggle: '.js-blog-submenu-toggle'
  }

  var init = function() {
    initializeEventListeners();
  }

  var initializeEventListeners = function() {
    $(settings.menuToggle).on('click', toggleMenu);
  }

  var toggleMenu = function(e) {
    e.preventDefault();

    $(this).toggleClass('active');
  }

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// MC: Collapse
// +++++++++++++++++++++
var collapse = function() {
  var settings = {
    title: ".js-collapse-button",
    content: ".js-collapse-content",
    que: ".js-que"
  }

  var init = function(){
    if ($(settings.title).length === 0) {
      return;
    }

    initializeEventListeners();
  }

  var initializeEventListeners = function() {

    $(settings.title).on('click', togglePanel);
  }

  var togglePanel = function(e) {
    var $this = $(this);
    var target = $this.data("collapseTarget");
    var $target = $(target);

    if ($(this).attr('aria-expanded') == 'false') {
      // Toggle the aria-expanded attribute
      $(this).attr('aria-expanded', true)

      // Show the content
      $target.addClass("show").slideDown(300)
      $(settings.que).text('hide all spices');
    } else {
      // Toggle the aria-expanded attribute
      $(this).attr('aria-expanded', false)

      // Hide the content
      $target.removeClass("show")

      if ($this.hasClass('js-mid-link')) {
        $target.slideUp(300);
      }
      $(settings.que).text('show all spices')
    }

    return false;
  };

  return {
    init: init
  }
}();


// +++++++++++++++++++++
// Videos
// +++++++++++++++++++++
var videos = (function(){

  var settings = {
    cover: ".js-video-cover"
  }

  var init = function(){
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    var iframe = $('iframe.vimeo-video') ;
    var playing = false;

    $(settings.cover).on( 'click', function () {
      $(this).find('img').fadeOut();
      $(this).addClass('fadeOut-before');
      var video = $(this).find('video');

      if (!playing) {
        video.trigger('play');
        playing = true;
      }

      if ( iframe.length > 0 ) {
        var player = new Vimeo.Player(iframe);
          player.play();
      }
    });
  }

  return {
      init: init
    }
})();


// ===============
// Search
// ===============
var search = (function(){

  var settings = {
    searchContainer: ".js-nav-search",
    searchBar: ".js-search-bar",
    searchResultsWrapper: ".js-predictive-search-container",
    searchResults: ".js-predictive-search-results",
    searchURL: "/search/suggest.json?q=<QUERY>&resources[type]=product,article,collection&resources[limit]=4",
    searchTemplate: "#PredictiveSearchTemplate",
    closeSearch: ".js-close-search"
  }

  var init = function(){
    if ($(settings.searchContainer).length) {
      initializeEventListeners();
    }
  }

  var handleSearchTerms = function(e){
    var code = e.code;
    if (code === "Enter") {
      // Don't submit while someone's typing
      e.preventDefault();
    }

    var $this = $(this);
    var value = $this.val();

    // mirror the value accross the other search bar
    $(settings.searchBar).not($this).val(value).focus();

    if (value) {
      getSearchResults(value);
    }
  }

  var getSearchResults = function(value){

    var url = settings.searchURL.replace("<QUERY>", value);
    var params = {
      url: url,
      dataType: "json",
      success: function(response){
        renderPredictiveSearch(response, value);
      },
      error: console.log
    }

    $.ajax(params);
  }

  var renderPredictiveSearch = function(response, query){
    if (response && response.resources && response.resources.results) {

      var $searchResultsWrapper = $(settings.searchResultsWrapper), $searchResults = $(settings.searchResults), data = {}, source = $(settings.searchTemplate).html(), template = Handlebars.compile(source);

      data = {
        hasCollections: !!response.resources.results.collections.length,
        collections: response.resources.results.collections,
        hasProducts: !!response.resources.results.products.length,
        products: response.resources.results.products,
        hasArticles: !!response.resources.results.articles.length,
        articles: response.resources.results.articles,
        query: query
      }

      $searchResults.html(template(data));
      $searchResultsWrapper.slideDown(300);
      addNoScroll();
    }
  }

  var closeSearchContainer = function(e){
    var $searchResultsWrapper = $(settings.searchResultsWrapper), $searchResults = $(settings.searchResults)

    $(settings.searchBar).val('');
    $(settings.searchBar).val('').eq(0).focus();
    $searchResultsWrapper.slideUp(300);
    $searchResults.empty();
    removeNoScroll();
  }

  var initializeEventListeners = function(){
    // throttle
    if (typeof $.throttle === 'undefined') {
      $(settings.searchBar).on('keyup', handleSearchTerms);
    } else {
      $(settings.searchBar).on('keyup', $.throttle(200, handleSearchTerms));
    }
    $(settings.closeSearch).on('click', closeSearchContainer);
  }

  return {
    init: init
  }
})();

// ===============
// Custom Select
// ===============
var customSelect = (function(){
  var settings = {
    customSelect: ".js-custom-select",
    selectTrigger: ".js-custom-trigger",
    selectOption: ".js-custom-option",
    hiddenSelect: ".js-hidden-select"
  }

  var init = function(){
    if (!$(settings.customSelect).length) return;

    initializeEventListeners()
  }

  var initializeEventListeners = function(){
    $(settings.selectTrigger).on('click', toggleSelect);
    $(settings.selectOption).on('click', setActiveOption);
  }

  var toggleSelect = function(e){
    $(settings.customSelect).toggleClass('open');
  }

  var setActiveOption = function(e){
    var $this = $(this);
    var value = $this.data('value');

    if (value) {
      var $otherOptions = $(settings.selectOption).not($this);
      var $selectContainer = $this.parents(settings.customSelect);
      var id = $selectContainer.data('for');
      var hiddenSelect = $("#" + id);

      hiddenSelect.val(value).change();

      $this.addClass("active");
      $otherOptions.removeClass("active");
      toggleSelect();
    }
  }

  return { init: init }
})();

var modal = (function(){
  var settings = {
    modal: '.js-modal',
    modalTrigger: ".js-modal-trigger",
  }

  var init = function(){
    if (!$(settings.modal).length) return;
    initializeEventListeners()
  }

  var initializeEventListeners = function(){
    $(document).on('click', settings.modalTrigger, toggleModal);
  }

  var toggleModal = function(e){
    var $this = $(this);
    var modalRef = $this.data('modal');
    var $modal = $(settings.modal + '[data-modal="' + modalRef + '"]');

    $modal.toggleClass('active');
  }

  return {
    init: init
  }

})();


// BUNDLER JS
var bundler = (function(){
  var settings = {
    bundlerContainer: ".js-bundler-container",
    bundlerInput: ".js-bundler-pack",
    bundlerBtn: ".js-bundler-btn",
    bundlerCard: ".js-bundler-card",
    bundlerQty: ".js-bundler-qty",
    bundlerQtyBtn: ".js-bundler-qty-btn",
    removeItem: ".js-remove-from-pack",
    bundlerPrice: ".js-bundler-price",
    bundlerList: ".js-bundler-list",
    bundlerTotalQty: ".js-bundler-total-selected",
    spiceToggle: ".js-toggle-spices",
    spiceContainer: ".js-spices-container"
    // bundlerLimit: ".js-bundler-limit"
  }

  var packSize = 3;
  var currentVariant;
  // image, title, id, quantity
  var itemsInBundle = []

  var init = function(){
    if ($(settings.bundlerContainer).length === 0) return

    initEventListeners()
  }

  var initEventListeners = function(){
    $(settings.bundlerInput).on('change', handlePackChange);
    $(settings.bundlerQty).on('change', handleItemChange);
    $(settings.bundlerQtyBtn).on('click', triggerItemChange);
    $(settings.bundlerBtn).on('click', handleBundleSubmit);
    $(settings.removeItem).on('click', removeItemFromPack);
    $(settings.spiceToggle).on('click', toggleSpiceContainer);
  }

  var toggleSpiceContainer = function(e){
    var $spiceContainer = $(settings.spiceContainer);

    $spiceContainer.slideToggle(300).toggleClass('active');

    if ($spiceContainer.hasClass('active')) {
      $(this).text("Hide Selected Spices -")
    } else {
      $(this).text("View Selected Spices +")
    }
  }

  var removeItemFromPack = function(e){

    var foundId = $slot.attr('data-id');

    var $foundCard = $(settings.bundlerCard + '[data-id="' + foundId + '"]');
    var $foundInput = $foundCard.find(settings.bundlerQty);

    var value = $foundInput.val()

    if (value && value > 0) {
      value -= 1;
    }

    $foundInput.val(value).change();
  }

  var handlePackChange = function(e){
    var size = $(this).data('limit');
    var value = $(this).val();
    var price = $(this).data('price');

    if (size) {
      packSize = parseInt(size);
    }

    updatePackItems();
    updateBundlerCards();
    // updateDiscountMessage();
    updateBundlerBtn();
    $(settings.bundlerPrice).text(price);
  }

  var updateBundlerCards = function(){
    if (getTotalQty() === packSize) {
      $(settings.bundlerCard).not(".active").addClass('disabled')
      $(settings.bundlerCard).not(".active").find(settings.bundlerQtyBtn).attr('disabled', true);
    } else {
      $(settings.bundlerCard).removeClass("disabled");
      $(settings.bundlerCard).find(settings.bundlerQtyBtn).attr('disabled', false);
    }
  }

  // var updateDiscountMessage = function(){
  //
  //   var $limit = $(settings.bundlerLimit);
  //
  //   $limit.text(packSize);
  //
  //   if (packSize === 3) {
  //     $savings.text("5");
  //   } else if (packSize === 4 ) {
  //     $savings.text("7");
  //   } else if (packSize === 5) {
  //     $savings.text("9");
  //   }
  // }

  var triggerItemChange = function(e){
    var $this = $(this);
    var $input = $(this).siblings(settings.bundlerQty);
    var value = parseInt($input.val());
    var $card = $this.parents(settings.bundlerCard);

    if ($this.attr('name') === "increase") {
      var totalInPack = getTotalQty();
      var totalRemaining = packSize - totalInPack;

      if (1 <= totalRemaining) {
        value += 1;
      }
    } else {
      if (value - 1 >= 0) {
        value -= 1
      }
    }

    $input.val(value).change();
  }

  var handleItemChange = function(e){

    var value = parseInt($(this).val());
    var $card = $(this).parents(settings.bundlerCard);
    var id = $card.data('id');
    var title = $card.data('title');

    if (value === 0) {
      $card.removeClass('active');
    } else {
      $card.addClass('active');
    }

    var foundItem = itemsInBundle.find(function(item) {
      return item.id === id
    })

    if (foundItem) {
      foundItem.quantity = value;
    } else {
      itemsInBundle.push({
        title: title,
        quantity: value,
        id: id
      })
    }

    itemsInBundle = itemsInBundle.filter(function(item){
      return item.quantity > 0
    })

    renderBundlerItems();
    updateBundlerCards();
  }

  var updatePackItems = function(){
    // same logic as diaspora...
    var totalQty = getTotalQty();
    if (totalQty > packSize) {
      var numberToRemove = totalQty - packSize;

      $(settings.bundlerCard + ".active").each(function(index, card){
        var $card = $(card);
        var $input = $card.find(settings.bundlerQty);
        var quantity = parseInt($input.val());

        if (numberToRemove > 0) {
          if (quantity > numberToRemove) {
            // check if the quantity is greater than numberToRemove
            // => remove numberToRemove from quantity
            var newQty = quantity - numberToRemove;
            numberToRemove = 0;
            $input.val(newQty).change();
          } else if (numberToRemove >= quantity){
            // check if quantity is less than numberToRemove
            // => remove the entire quantity (set quantity to zero)
            var newQty = 0;
            $input.val(newQty).change();
            numberToRemove = numberToRemove - quantity;
          }
        }
      })
    }
  }

  var renderBundlerItems = function(){
    // @arren needs to render images, change button text + state
    var $bundlerList = $(settings.bundlerList);

    var totalQty = getTotalQty();

    if (totalQty > 0) {
      $bundlerList.addClass('active');
    } else {
      $bundlerList.removeClass('active');
    }

    $bundlerList.empty();

    itemsInBundle.forEach(function(item){
      if (item.quantity > 1) {
        var $listItem = $("<li>" + item.title + " x<span class='bold'> " + item.quantity + "</span></li>");
      } else {
        var $listItem = $("<li>" + item.title + "</li>");
      }
      $bundlerList.append($listItem);
    });

    // update button state
    updateBundlerBtn();

    $(settings.bundlerTotalQty).text(totalQty);
  }

  var getTotalQty = function(){
    var total = 0;

    itemsInBundle.forEach(function(item){
      total += item.quantity
    })

    return total;
  }

  var updateBundlerBtn = function(){
    var $btn = $(settings.bundlerBtn);
    var totalInPack = getTotalQty();
    var totalRemaining = packSize - totalInPack;

    // if (variantId) {
    //   $btn.attr('data-id', variantId);
    // }

    if (totalRemaining === 0) {
      $btn.text("Add To Cart");
      $btn.attr('disabled', false);
    } else {
      $btn.text("Add " + totalRemaining + " More");
      $btn.attr('disabled', true);
    }
  }

  var handleBundleSubmit = function(e){
    var $this = $(this);
    var id = $('.js-bundler-pack:checked').val();

    var data = {
      items: [{
        id: id,
        quantity: 1,
        properties: {}
      }]
    }

    itemsInBundle.forEach(function(item){
      var idKey = "_" + item.id;

      data.items[0].properties[idKey] = item.quantity;
      data.items[0].properties[item.title] = item.quantity;
    })

    var params = {
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      method: "POST",
      success: function(item){
        cart.onCartUpdate();
      }
    }

    $.ajax(params);
  }

  return {
    init: init
  }
})()

var article = (function(){
  const settings = {
    articleContainer: '[data-section-type="article"]'
  }

  const normalizeArticleContent = () => {
    // Remove style attibutes
    $(settings.articleContainer).find("[style='text-align: center;']").attr("style", "")
    $(settings.articleContainer).find('img').attr("style", "").attr('width', '').attr('height', '');
  }

  var init = () => {
    if ($(settings.articleContainer).length) {
      normalizeArticleContent();
      $('.js-article-print').on('click', printArticle);
    }
  }

  var printArticle = () => {
    // $('body').addClass("printing");
    window.print();
  }

  return { init }
})()


var reChargePortal = (function(){
  var activeProduct;

  var settings = {
    editFrequency: ".js-edit-frequency",
    editChargeDate: ".js-edit-next-charge-date",
    subscriptionsPageCards: '.rc_subscription_card_element_wrapper'
  }

  var init = function(){
    if (!location.pathname.includes("tools/recurring")) return;

    let $productTitleEl = $('.edit_subscription_info-product').find('h5');
    activeProduct = $productTitleEl.text().trim();

    if (activeProduct === "Flavor Club") {
      var $editFrequency = $(settings.editFrequency);
      var $editChargeDate = $(settings.editChargeDate);

      if ($editFrequency.length) {
        var $clonedEditFrequency = $editFrequency.clone();
        $clonedEditFrequency.removeClass('js-edit-frequency')
        $clonedEditFrequency.addClass("pointer-cursor")
        $clonedEditFrequency.attr('data-date', '').attr('data-subscriptioniid', '').attr('data-status', '')
        $clonedEditFrequency.find('svg').remove();

        $editFrequency.replaceWith($clonedEditFrequency)
      }

      if ($editChargeDate.length) {
        var $clonedChargeDate = $editChargeDate.clone();
        $clonedChargeDate.removeClass('js-edit-next-charge-date')
        $clonedChargeDate.addClass("pointer-cursor")
        $clonedChargeDate.attr('data-date', '').attr('data-subscriptioniid', '').attr('data-status', '')
        $clonedChargeDate.find('svg').remove();

        $editChargeDate.replaceWith($clonedChargeDate)
      }
    }

    adjustFlavorClubCards()
  }


  const adjustFlavorClubCards = function(){
    let allCards = $(settings.subscriptionsPageCards);
    allCards.each(function(index, el){
      let $this = $(el);
      let title = $this.find('.rc_order_title').text().trim();

      if (title === "Chef Discovery Subscription" || title === "Flavour Club" || title.includes("Flavour Club")) {
        $('.page-title').text("Subscriptions")

        $this.find('.rc_order_title').text("Flavour Club")
        // Change expired flag
        $this.find('.expired-icon').text("Pre-Paid")
        // remove re-activate button
        let $button = $this.find('button.expired');
        let $parentDiv = $button.parent('div')
        $button.remove()

        let addressLink = $('.js-addresses-page a').attr('href');

        let html = `<h2 class="h2 mb-1">Flavour Club Details</h2>
                    <p class="large">If you need to change your shipping address, visit the <a href="${addressLink}">"SHIPPING ADDRESSES"</a> tab above.</p>
                    <p class="large">The Flavour Club will ship in 4 installments:</p>
                    <ul>
                      <li>February 2022</li>
                      <li>May 2022</li>
                      <li>August 2022</li>
                      <li>November 2022</li>
                    </ul>`

        $parentDiv.css({padding: '0 40px', maxWidth: '520px'});
        $parentDiv.html(html);
      }
    })
  }


  return {
    init: init
  }

})()



// +++++++++++++++++++++
// Initialize all custom JS modules here
// +++++++++++++++++++++
var init = function(){
  article.init();
  navigation.init();
  cart.init();
  dropdownMenus.init();
  search.init();
  filters.init();
  slickSliders.init(); // has to be after filters for the featured collection
  accessibility.init();
  accordion.init();
  productPage.init();
  account.init();
  animations.init();
  collectionATC.init();
  blogPage.init();
  collapse.init();
  videos.init();
  customSelect.init();
  modal.init();
  bundler.init();
  reChargePortal.init();
}

$(document).ready(function() {
  init();
});
